import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// Guest pages (login, register, etc.)
const Login = lazy(() => import('../pages/auth/Login'));
const Register = lazy(() => import('../pages/auth/Register'));
const GuestRoute = lazy(() => import('./GuestRoute'));
const ResetPassword = lazy(() => import('../pages/auth/ResetPassword'));
const CreateNewPassword = lazy(() => import('../pages/auth/NewPassword'));
const SplashScreen = lazy(() => import('../pages/SplashScreen'));

const guestRoutes = [
  // Make root path render SplashScreen
  {
    path: '/',
    element: (
      <GuestRoute>
        <SplashScreen />
      </GuestRoute>
    ),
  },
  {
    path: '/splashscreen',
    element: (
      <GuestRoute>
        <SplashScreen />
      </GuestRoute>
    ),
  },
  {
    path: '/login',
    element: (
      <GuestRoute>
        <Login />
      </GuestRoute>
    ),
  },
  {
    path: '/register',
    element: (
      <GuestRoute>
        <Register />
      </GuestRoute>
    ),
  },
  {
    path: '/reset-password',
    element: (
      <GuestRoute>
        <ResetPassword />
      </GuestRoute>
    ),
  },
  {
    path: '/new-password',
    element: (
      <GuestRoute>
        <CreateNewPassword />
      </GuestRoute>
    ),
  },
  // Fallback route - if user tries to access an invalid guest route, redirect to splash screen
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];

export default guestRoutes;